import React, { useState } from "react";
import "../../Merchant/EditProfileForm/editprofileform.scss";
import BreadCrumsHeader from "../../common/BreadCrums";
import FormLayout from "../../common/FormLayout";
import { useFormik } from "formik";
import { updatePasswordSchema } from "../../../utils/validationSchemas";
import UpdatePassword from "../../Merchant/EditProfileForm/UpdatePassword";
import { useSelector } from "react-redux";
import profileImagePlaceholder from "../../../Assets/Images/Ellipse 3.svg";
import { getS3PublicUrl } from "../../../utils/s3";

const AdminEditProfileFormPage = () => {
  const [isUpdatePassword, setIsUpdatePassword] = useState(true);
  const user = useSelector((s) => s?.authReducer?.tokenData?.user) || {};

  const items = [
    { title: "Profile" },
    { title: "Edit Profile" },
  ];

  const formik = useFormik({
    initialValues: {
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
    enableReinitialize: true,
    validationSchema: updatePasswordSchema,
    onSubmit: async () => {
      // Submit handling is implemented inside UpdatePassword via dispatched action
    },
  });

  const { handleBlur, handleChange, handleSubmit, errors, touched, setFieldValue } = formik;

  return (
    <>
      <BreadCrumsHeader heading="Edit Profile" items={items} form={true} />
      <FormLayout
        title={"Profile Information"}
        content={
          <form onSubmit={handleSubmit} className="px-5">
            <div className="mt-5 w-full flex justify-between items-center">
              {isUpdatePassword ? (
                <p
                  className="cursor-pointer font-poppins font-[400] sm:text-[12px] md:text-[14px] text-[#00ADEF] text-center leading-[18px]"
                  onClick={() => setIsUpdatePassword(false)}
                >
                  View Profile Information
                </p>
              ) : (
                <p
                  className="cursor-pointer font-poppins font-[400] sm:text-[12px] md:text-[14px] text-[#00ADEF] text-center leading-[18px]"
                  onClick={() => setIsUpdatePassword(true)}
                >
                  Update Password
                </p>
              )}
            </div>
            {isUpdatePassword ? (
              <UpdatePassword
                values={formik.values}
                errors={errors}
                touched={touched}
                handleBlur={handleBlur}
                handleChange={handleChange}
                setFieldValue={setFieldValue}
              />
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
                <div className="col-span-1">
                  <label className="block text-[14px] text-[#303030] mb-2">Name</label>
                  <input
                    type="text"
                    disabled
                    value={user?.name || ""}
                    className="w-full h-[45px] px-3 rounded border border-[#D9D9D9] bg-[#F5F5F5] text-[#8C8C8C] cursor-not-allowed"
                  />
                </div>
                <div className="col-span-1">
                  <label className="block text-[14px] text-[#303030] mb-2">Email</label>
                  <input
                    type="email"
                    disabled
                    value={user?.email || ""}
                    className="w-full h-[45px] px-3 rounded border border-[#D9D9D9] bg-[#F5F5F5] text-[#8C8C8C] cursor-not-allowed"
                  />
                </div>

                <div className="col-span-1">
                  <label className="block text-[14px] text-[#303030] mb-2">Phone Number</label>
                  <input
                    type="text"
                    disabled
                    value={user?.phone || user?.contactPersonNumber || ""}
                    className="w-full h-[45px] px-3 rounded border border-[#D9D9D9] bg-[#F5F5F5] text-[#8C8C8C] cursor-not-allowed"
                  />
                </div>

                <div className="col-span-1 md:col-span-2">
                  <label className="block text-[14px] text-[#303030] mb-1">Upload logo</label>
                  <div className="flex items-center gap-8">
                    <div className="relative h-[80px] w-[80px] rounded-[10px] border-2 border-solid border-[#E4E3E4] overflow-hidden flex justify-center items-center">
                      <img
                        src={(function(){
                          const logo = user?.logo || user?.merchant?.logo || user?.fundraiser?.logo;
                          if (logo) {
                            return getS3PublicUrl(logo);
                          }
                          return profileImagePlaceholder;
                        })()}
                        alt="logo"
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                    <div className="flex flex-col justify-start">
                      <span className="text-[12px] font-poppins text-[#00ADEF]">File type: must be png, jpeg, jpg</span>
                      <span className="text-[12px] font-poppins text-[#00ADEF]">Max image size: 5MB</span>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="col-span-12 text-end mt-14">
              <button
                type="submit"
                className={`w-[30%] lg:w-[15%] h-[45px] rounded-[5px] bg-[#00ADEF] text-[16px] font-[500] text-[#FFFFFF] ms-2`}
              >
                Save
              </button>
            </div>
          </form>
        }
      />
    </>
  );
};

export default AdminEditProfileFormPage;


